import { render, staticRenderFns } from "./IconLayoutDashboard.vue?vue&type=template&id=c88b5530"
import script from "./IconLayoutDashboard.vue?vue&type=script&lang=js"
export * from "./IconLayoutDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports